import ObrasAPI from '../../../services/APIObras';
import type { AutocompleteOptionsSource } from '../../../components/Filters/Components/AutocompleteMultichoice/CustomAutocomplete/AutocompleteOptionsSource';

const collaboratingCompaniesOptionsSource: AutocompleteOptionsSource = {
  minQueryLength: 3,
  pageSize: 25,
  allowFreeSolo: false,
  search: async (query, page, pageSize) => {
    const response = await ObrasAPI.getInstance().getCollaboratingCompaniesAPI(query, page, pageSize);
    return {
      options: response.data.map((company) => ({
        code: company.name,
        name: company.name,
      })),
      hasNextPage: response.hasNextPage,
    };
  },
};

export default collaboratingCompaniesOptionsSource;
